<template>
  <div
    :class="twMerge('pt-6 sticky bottom-0 bg-idle-white', props.appendClass)"
  >
    <TsRow
      is-multiline
      append-class="pt-1 shadow-upward bg-[#F7FBFE] mb-20 max-md:mb-0"
    >
      <TsColumn append-class="is-2 max-md:is-6">
        <TsButton
          v-bind="props.backButton"
          :label="useTranslation('back' , 'Rug')"
          @click="emit('back')"
          block
          outlined
          data-testid="pro-card-form-bottom-bar-back-button"
        >
          <slot name="back"></slot>
        </TsButton>
      </TsColumn>
      <slot name="middle"></slot>
      <TsColumn append-class="is-2 max-md:is-6">
        <TsButton
          :label="useTranslation('next' , 'Volgende')"
          v-bind="props.nextButton"
          @click="emit('next')"
          block
          data-testid="pro-card-form-bottom-bar-next-button"
        >
          <slot name="next"></slot>
        </TsButton>
      </TsColumn>
      <TsColumn v-if="!props.hideSaveDraft" append-class="is-2 max-md:is-6">
        <TsButton
           :label="useTranslation('saveProgress','Bewaar vooruitgang')"
          v-bind="props.saveButton"
          @click="emit('draft')"
          block
          data-testid="pro-card-form-bottom-bar-save-button"
        >
          <slot name="save"></slot>
        </TsButton>
      </TsColumn>
      <slot name="right"></slot>
    </TsRow>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

type Props = {
  appendClass?: string;
  backButton?: Record<string, any>;
  nextButton?: Record<string, any>;
  saveButton?: Record<string, any>;
  hideSaveDraft?: boolean;
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  appendClass: "",
});

const emit = defineEmits<{
  back: any;
  next: any;
  draft: any;
}>();
</script>
